import React from 'react';
import './style.scss';

const DashboardCardSkeleton = () => (
   <div className="col s12 m6 l3 card-layout">
      <div className="card-panel white dashboard-panels center skeleton-card-panel">
         <div className="skeleton-card-panel__pulse skeleton-card-panel__title" />
         <div className="skeleton-card-panel__pulse skeleton-card-panel__icon" />
         <div className="skeleton-card-panel__pulse skeleton-card-panel__separator" />
         <div className="skeleton-card-panel__pulse skeleton-card-panel__text" />
         <div className="skeleton-card-panel__pulse skeleton-card-panel__text skeleton-card-panel__text--short" />
      </div>
   </div>
);

export default DashboardCardSkeleton;
